import { Store } from '@ngxs/store';
import { Observable, fromEventPattern } from 'rxjs';

export function startPeriodicAction<TStartAction, TStopAction>(store: Store, start: TStartAction, stop: TStopAction): Observable<void> {
  return fromEventPattern(
    () => store.dispatch(start),
    () => store.dispatch(stop),
  );
}
